import { BrowserRouter, Routes, Route } from 'react-router-dom';
import React from "react";
import Navbar from './component/Navbar/navbar';
import ScrollToTop from './component/ScrollToTop/ScrollToTop';
import MainPage from './pages/MainPage';
import About from './pages/About/About';
import Projects from './pages/Projects/Projects';
import Skills from './pages/Skills/Skills';
import Contact from './pages/Contact/Contact';
import Certificates from './pages/Certificates/Certificates';
import Footer from './component/Footer/Footer';

/* ---------------- APP COMPONENT ---------------- */


function App() {
  return (
    <BrowserRouter>
      {/* Navigation */}
      <Navbar />
      <ScrollToTop />

      {/* Routes */}
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/certificates" element={<Certificates />} />
        {/* <Route path="/contact" element={<Contact />} /> */}
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
export default App;
